<template>
  <div :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <!-- 忘記密碼 -->
    <div class="px-2 py-4 lg:py-6 xl:py-8 max-w-lg lg:max-w-2xl mx-auto">
      <div class="mx-auto mb-4 sm:border border-gray-700 rounded overflow-hidden">
        <div class="mx-auto hidden sm:block overflow-hidden w-full forgotPwdBanner">
          <img class="w-full h-full object-cover block" src="~@/assets/images/banner/back.webp" alt="忘記密碼">
        </div>
        <div class="forgetPwd w-full flex justify-center">
          <div class="w-full max-w-lg pt-4 lg:pt-10">
            <div class="dialog__header">
              <h6 class="text-NotoSansRegular text-base text-center textColorDarkBlack">忘記密碼嗎？</h6>
              <h6 class="text-NotoSansRegular text-base text-center textColorDarkBlack">沒問題，我們將會寄一封重設密碼通知信給您</h6>
            </div>
            <div class="dialog__body">
              <div class="bg-white rounded px-8 pt-6 pb-8 mb-4 text-NotoSansRegular" id="form-forgetPwd" autocomplete="off">
                <div class="mb-4 relative">
                  <input type="email" class="text-sm input-text appearance-none border border-gray-700 rounded w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:shadow-outline"
                    id="input2" placeholder="請輸入您的會員帳(E-mail)，以接收密碼" v-model.trim="forgetPwdEmail" autocomplete="none" name="forgetEmail" />
                  <label class="label-helper block textColorDarkBlack text-xs font-bold mb-2" for="input2">請輸入您的會員帳(E-mail)，以接收密碼</label>
                </div>
                <div class="flex justify-center">
                  <button class="forgetBtn mt-4 shadow button-red focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded w-full lg:w-2/3 mx-auto"
                    type="button" @click="forgetPwdSubmit" :disabled="isReseting || isCoundown" :class="{ disabledBtn: !this.canClick }" >
                    {{ content }}<font-awesome-icon icon="circle-notch" spin v-if="isReseting" />
                  </button>
                </div>
                <router-link :to="{ name: 'login' }" class="mt-6 cursor-pointer text-sm py-2 px-3">←返回</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import { mapGetters } from 'vuex'
import axios from 'axios'
import Regex from '@/components/modules/regex'
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'ForgotPwd',
  metaInfo () {
    return {
      title: '忘記密碼',
      titleTemplate: null
    }
  },
  data () {
    return {
      forgetPwdEmail: null,

      isReseting: false,
      isCoundown: false,

      content: '送出',
      totalTime: 500,
      canClick: true
    }
  },
  components: {
  },
  mixins: [
    Regex,
    sweetAlert
  ],
  watch: {
  },
  computed: {
    ...mapGetters([
      'authorized',
      'userRole'
    ])
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    forgetPwdSubmit () {
      let self = this
      if ((!self.forgetPwdEmail || !self.rexEmail(self.forgetPwdEmail)) && !self.isCoundown) {
        self.alertPop('warning', 'E-mail尚未填寫或格式不正確')
        // self.$store.dispatch('updateAlert', { isAlert: true, isHead: false, alertMsg: 'E-mail尚未填寫或格式不正確', type: 'alert' })
      } else if (self.forgetPwdEmail && self.rexEmail(self.forgetPwdEmail) && !self.isCoundown) {
        self.isReseting = true
        axios.post(`/password/email?email=${self.forgetPwdEmail}`)
          .then((response) => {
            console.log(response.data.status)
            self.isReseting = false
            if (response.data.email === "We can't find a user with that e-mail address.") {
              self.alertPop('warning', '此帳號不存在!!')
              // self.$store.dispatch('updateAlert', { isAlert: true, isHead: false, alertMsg: '此帳號不存在!!', type: 'alert' })
            } else if (response.data.status === 'We have e-mailed your password reset link!') {
              self.countDown()
              self.alertPop('warning', '系統將自動發送密碼變更信至您的信箱，請利用該信來變更您的密碼。')
              // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '系統將自動發送密碼變更信至您的信箱，請利用該信來變更您的密碼。', type: 'alert' })
            }
          })
          .catch(() => {
            self.isReseting = false
          })
      }
    },
    countDown () {
      let self = this
      if (!self.canClick) return
      self.canClick = false
      self.content = self.totalTime + 's'
      self.isCoundown = true
      let clock = window.setInterval(() => {
        self.totalTime--
        self.content = self.totalTime + 's'
        if (self.totalTime < 0) {
          window.clearInterval(clock)
          self.content = '送出'
          self.totalTime = 500
          self.canClick = true
          self.isCoundown = false
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.forgotPwdBanner {
    max-height: 200px;
  }

  .dialog__header {
    font-size: 20px;
  }
  .dialog__body {
    .fb-btn {
      transition: 0.3s;
      background-color: #3b5998;
      &:hover {
        background-color: #29487d;
      }
    }
    .lineBtn {
      transition: 0.3s;
      background-color: #00C300;
      &:hover {
        background-color: #00E000;
      }
      &:focus {
        background-color: #00E000;
      }
    }
    .disableLine {
      background-color: #C6C6C6;
      cursor: not-allowed;
    }
    #my-signin2{
      .abcRioButtonContentWrapper {
        display: flex;
        justify-content: center;
      }
      width: 100% !important;
      .abcRioButton, .abcRioButtonBlue {
        background-color: white;
        width: 100% !important;
        height: 40px !important;
        border-radius: 0.25rem !important;
        height: auto;
        &:hover {
          box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
        }
        .abcRioButtonContents {
        font-weight: 700 !important;
        font-size: 1rem !important;
        color: black;
        }
      }
    }
    .social-login-option:before, .social-login-option:after {
        background-color: #dde1e4;
        content: "";
        display: inline-block;
        height: 1px;
        position: relative;
        vertical-align: middle;
        width: 45%;
    }
    .social-login-option:before {
      right: .5rem;
    }
    .social-login-option:after {
      left: .5em;
    }
  }

  .input-text {
    background-color: white;
    border: 1px solid #cccccc;
    padding: 8px 4px;
    position: relative;
    width: 100%;
    z-index: 3;
  }

  .label-helper {
    position: absolute;
    opacity: 0;
    transition: .2s bottom, .2s opacity;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  .input-text:focus + .label-helper, .input-text:invalid + .label-helper {
    bottom: 95%;
    line-height: 1;
    opacity: 1;
    }

  .input-text:not(:placeholder-shown) ~ label,
  .input-text:-webkit-autofill ~ label {
    bottom: 95%;
    line-height: 1;
    opacity: 1;
  }

    .disabledBtn {
      background-color: gray !important;
      color:#ffffff;
      cursor: not-allowed;
      &:hover {
        background-color: gray !important;
        color:#ffffff;
        cursor: not-allowed;
      }
    }
</style>
